<template>
  <quick-rfq-parts :isStatusAvailable="false" />
</template>

<script>
export default {
  name: 'QuickRFQPartAll',
  components: {
    'quick-rfq-parts': () => import(/* webpackChunkName: 'QuickRFQPart' */ '@/components/Shared/RFQ_QuickRFQParts')
  }
}
</script>
